import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import FalconSite from "./FalconSite";
import Story from "./Story";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FalconSite />} />
        <Route path="/story" element={<Story />} />
      </Routes>
    </Router>
  );
}
